//-- image-accordion - text-accordion - accordion js function start
const allAccordionsElToOpenOnInit = document.querySelectorAll(
  "[data-accordion-open-on-load]"
);
const allAccordions = document.querySelectorAll("[data-accordion]");

const handleAccordion = function (e) {
  const accordion = this;
  const accordionBody = accordion.querySelector("[data-accordionBody]");

  if (accordion.classList.contains("accordion_open")) {
    accordionBody.style.maxHeight = "0px";
    // remove open class on accordion element
    accordion.classList.remove("accordion_open");
  } else {
    // close the open accordion first
    const accrdionOpenEl =
      accordion.closest("[data-accordions]").querySelector(".accordion_open") ||
      null;
    if (accrdionOpenEl) {
      accrdionOpenEl.click();
    }

    accordionBody.style.maxHeight = accordionBody.scrollHeight + "px";

    // add open class on accordion element
    accordion.classList.add("accordion_open");
  }
};

allAccordions.forEach((accordion) => {
  accordion.addEventListener("click", handleAccordion);
});

// set accordion as open where elements have this data attr '[data-accordion-open-on-load]'
allAccordionsElToOpenOnInit.forEach((accordion) => {
  const accordionBody = accordion.querySelector("[data-accordionBody]");

  // toggle class on accordion element
  accordion.classList.add("accordion_open");

  accordionBody.style.maxHeight = accordionBody.scrollHeight + "px";
});

// image-accordion - text-accordion - accordion js function end

// products to cart via api
function productsToCart(productsIdArray) {
  return new Promise((resolve, reject) => {
    let formData = {
      items: [],
    };
    productsIdArray.forEach((el) => {
      formData.items.push({
        id: el,
        quantity: 1,
      });
    });

    const postData = JSON.stringify(formData);
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;",
      },
      body: postData,
    })
      .then((response) => {
        if (response.ok) {
          // Resolve the promise with a success message or any relevant data
          resolve("Products added to cart successfully.");
        } else {
          // Reject the promise with an error message
          reject("Failed to add products to cart.");
        }
      })
      .catch((error) => {
        // Reject the promise with an error message
        reject("Error: " + error);
      });
  });
}
